import { Component, OnInit, ViewChild } from '@angular/core';
import { MaterialModule } from '../material';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { HeaderComponent } from '../header/header.component';
import { ToastService } from '../Services/toast.service';
import { AuthService } from '../Services/auth.service';
import { NotificationService } from '../Services/notification.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterOutlet, MaterialModule, SidebarComponent, HeaderComponent],
  providers: [ToastService, AuthService, NotificationService],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent implements OnInit {
  @ViewChild('headerRef') headerComponent!: HeaderComponent;

  isSidebarCollapsed = false;
  shownMessages = new Set<string>();
  notification: any;
  constructor(
    private toastService: ToastService,
    private authService: AuthService,
    private notificationService: NotificationService
  ) { }
  ngOnInit(): void {
    const storedMessages = localStorage.getItem('shownNotifications');
    const shownMessages = new Set<string>(
      storedMessages ? JSON.parse(storedMessages) : []
    );
    
    const providerId = this.authService.getCurrentUserPID();
    this.notificationService.buildConnection(providerId);

    if (providerId) {
      this.notificationService.listenForNotifications((message: any) => {
        this.toastService.showSuccess(
          message.message
        );
        setTimeout(() => {
          if (this.headerComponent) {
            this.headerComponent.getAllNotifications();
          }
        });
      });
    }
  }

  onSidebarToggle(collapsed: boolean) {
    this.isSidebarCollapsed = collapsed;
  }
}
